import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { gsap } from 'gsap';

function AnimationContainer({ animation, children, classes }) {
  const { ref, inView } = useInView({ triggerOnce: true });
  const [hasRun, setHasRun] = useState(false);

  useEffect(() => {
    if (inView) {
      gsap.fromTo(
        '.fade-in',
        { opacity: 0, y: 10 },
        { opacity: 1, y: 0, duration: 0.5 }
      );
      setHasRun(true);
    }
  }, [inView]);

  return (
    <div ref={ref} className={`${classes} ${!hasRun ? animation : ''} animation-container`}>
      {children}
    </div>
  );
}

export default AnimationContainer;
